"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/no-danger */
const common_1 = require("@epic-core/common");
const ConfirmStage_1 = __importDefault(require("../../components/redeem/ConfirmStage"));
const LoginRequired_1 = __importDefault(require("../../components/redeem/LoginRequired"));
const PosaTemplate_1 = __importDefault(require("../../components/posa/PosaTemplate"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const RedeemStore_1 = __importDefault(require("../../stores/RedeemStore"));
const RedeemViewStyled_1 = __importDefault(require("./RedeemViewStyled"));
const react_router_1 = require("react-router");
const ValidateStage_1 = __importDefault(require("../../components/redeem/ValidateStage"));
const epic_alt_utils_1 = require("epic-alt-utils");
const epic_tracking_1 = __importDefault(require("epic-tracking"));
const query_string_1 = __importDefault(require("query-string"));
const route_1 = require("../../utils/route");
const GiftcardBox_1 = __importDefault(require("../../components/posa/GiftcardBox"));
const CardCallout_1 = __importDefault(require("../../components/posa/CardCallout"));
/**
 * RedeemView.
 *
 * Rendered when the Route matches /redeem
 */
let RedeemView = class RedeemView extends react_1.default.Component {
    static getStores() {
        return [RedeemStore_1.default];
    }
    static getPropsFromStores() {
        return {
            redeemStore: RedeemStore_1.default.getState()
        };
    }
    componentDidUpdate(prevProps) {
        const { redeemStore } = this.props;
        const { currentStage } = redeemStore;
        const { redeemStore: prevRedeemStore } = prevProps;
        const { currentStage: prevCurrentState } = prevRedeemStore;
        if (currentStage === 'CONFIRM' && prevCurrentState !== 'CONFIRM') {
            epic_tracking_1.default.trackEvent('Interaction', {
                interactionType: 'click',
                eventCategory: 'RedeemCode',
                eventAction: 'codeValidatedConfirmingUse'
            });
        }
    }
    render() {
        const { isLoggedIn, redeemStore, location, altSuccessPath, title, description, content, enablePosa, posaData, posaLink, giftcardConfig } = this.props;
        const { posaGiftCardRedeemUrl, posaGiftCardCardShow } = giftcardConfig;
        const { currentStage } = redeemStore;
        const config = this.props.config || {};
        const code = location.search ? query_string_1.default.parse(location.search).code || '' : '';
        let redeemViewContent;
        if (redeemStore.currentStage === 'SUCCESS') {
            return altSuccessPath ? (react_1.default.createElement(react_router_1.Redirect, { to: route_1.generateRouteTo(altSuccessPath, location) })) : (react_1.default.createElement("div", { className: "redeemView" },
                react_1.default.createElement(react_router_1.Redirect, { to: route_1.generateRouteTo('/redeem/confirmation', location) })));
        }
        if (!isLoggedIn || currentStage === 'LOGIN') {
            const loginParams = code ? `?${common_1.processParams({ code })}` : '';
            const loginPath = `${location.pathname}${loginParams}`;
            redeemViewContent = react_1.default.createElement(LoginRequired_1.default, { returnPath: loginPath });
        }
        else if (currentStage === 'VALIDATE') {
            redeemViewContent = (react_1.default.createElement(ValidateStage_1.default, { redeemStore: redeemStore, prefillCode: code, config: config, enablePosa: enablePosa, posaLink: posaLink, posaImage: posaData.image, isLoggedIn: isLoggedIn, nextStage: "CONFIRM", title: title, description: description }));
        }
        else if (currentStage === 'CONFIRM') {
            redeemViewContent = (react_1.default.createElement(ConfirmStage_1.default, { redeemStore: redeemStore, isLoggedIn: isLoggedIn, config: config, pageMapping: "code-redeem", nextStage: "SUCCESS" }));
        }
        return (react_1.default.createElement(RedeemViewStyled_1.default, { className: "redeemView" },
            react_1.default.createElement("div", { className: 'redeem-content' },
                redeemViewContent,
                react_1.default.createElement("div", { className: "posa-callout-container" },
                    enablePosa && posaData && (react_1.default.createElement(CardCallout_1.default, { boxClass: "vbucks-card", title: 'epic.code.redemption.posa.vbucks.title', redeemLink: "/vbuckscard", imgSrc: "https://cdn2.unrealengine.com/fn-vbuckscards-1b075ef6e2a5.svg", extra: react_1.default.createElement(PosaTemplate_1.default, { Tag: "div", isTemplate: true, className: "posa-help", string: posaData.needHelp }) })),
                    posaGiftCardCardShow && react_1.default.createElement(GiftcardBox_1.default, { showDesc: false, posaGiftCardRedeemUrl: posaGiftCardRedeemUrl })),
                content && isLoggedIn && (react_1.default.createElement(PosaTemplate_1.default, { Tag: "div", isTemplate: true, className: "site-block-content", dangerouslySetInnerHTML: { __html: content } }))),
            this.props.redeemStore.loading ? this.props.loadScreen : null));
    }
};
RedeemView.propTypes = {
    location: prop_types_1.default.object,
    redeemStore: prop_types_1.default.object,
    config: prop_types_1.default.object,
    isLoggedIn: prop_types_1.default.bool,
    loadScreen: prop_types_1.default.node,
    altSuccessPath: prop_types_1.default.string,
    title: prop_types_1.default.string,
    description: prop_types_1.default.string,
    content: prop_types_1.default.string,
    enablePosa: prop_types_1.default.bool,
    signInPosa: prop_types_1.default.string,
    signOutPosa: prop_types_1.default.string,
    posaData: prop_types_1.default.object,
    posaLink: prop_types_1.default.string,
    giftcardConfig: prop_types_1.default.object
};
RedeemView.defaultProps = {
    title: '',
    description: '',
    content: '',
    enablePosa: false,
    signInPosa: '',
    signOutPosa: ''
};
RedeemView = __decorate([
    epic_alt_utils_1.connectToStores
], RedeemView);
exports.default = RedeemView;
//# sourceMappingURL=RedeemView.js.map